import { msg } from '@lingui/core/macro';
import { i18n } from 'shared/i18n';

// Дескрипторы, а не строки: константа уровня модуля застыла бы на языке старта.
export const WALLET_TOPUP_RECEIPT_EMAIL_ERROR = msg`Укажите email для чека`;
export const WALLET_TOPUP_NOT_ENOUGH_MONEY = msg`Недостаточно средств на балансе`;
export const WALLET_TOPUP_CARD_DISABLED = msg`Оплата картой временно недоступна`;

export function walletTopupErrorMessage(error: unknown, fallback: string): string {
  const message = rawErrorMessage(error);
  if (message == null) {
    return fallback;
  }

  if (message === 'Not enough money') {
    return i18n._(WALLET_TOPUP_NOT_ENOUGH_MONEY);
  }

  if (message === 'Card payments are temporarily unavailable') {
    return i18n._(WALLET_TOPUP_CARD_DISABLED);
  }

  if (isReceiptEmailError(message)) {
    return i18n._(WALLET_TOPUP_RECEIPT_EMAIL_ERROR);
  }

  if (/[а-яё]/i.test(message)) {
    return message;
  }

  return fallback;
}

function rawErrorMessage(error: unknown): string | null {
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string' && error.message) {
    return error.message;
  }

  return null;
}

function isReceiptEmailError(message: string): boolean {
  const lower = message.toLowerCase();

  return (
    lower.includes('email') ||
    message.includes('Variable "$input"') ||
    lower.includes('got invalid value') ||
    lower.includes('required type') ||
    message === 'This value should not be blank.' ||
    message === 'This value is not a valid email.'
  );
}
